interface handleLogoutProps {
	account: any;
	instance: any;
}

const handleLogout = ({ account, instance }: handleLogoutProps) => {
	try {
		// Clear application-specific session data before logout
		sessionStorage.removeItem("entitlement");

		// Use manual cleanup immediately to avoid any Microsoft logout popups
		// This ensures we only log out of the portal, never the Microsoft account
		manualLogoutCleanup();
	} catch (error) {
		console.error("Logout failed:", error);
		// Force page reload as last resort
		window.location.reload();
	}
};

// Fallback function for manual cleanup
const manualLogoutCleanup = () => {
	try {
		// Clear all session storage to reset application state
		sessionStorage.clear();

		// Clear MSAL-related localStorage items
		Object.keys(localStorage).forEach((key) => {
			if (key.includes("msal")) {
				localStorage.removeItem(key);
			}
		});

		// Force immediate page reload to prevent any API calls from continuing
		// This stops all React components and prevents the "no account" errors
		window.location.reload();
	} catch (error) {
		console.error("Manual cleanup failed:", error);
		// Last resort: navigate to origin to force fresh start
		window.location.href = window.location.origin;
	}
};

export { handleLogout };
